import { PropsWithChildren } from 'react';

export const ButtonGroup = ({ children }: PropsWithChildren) => (
    <div data-component="button-group" className="r-my-4 r-flex r-flex-wrap r-items-center r-gap-4 [&>.resurs-button]:r-mr-0">
        {children}
    </div>
);
